import { useWindowDimensions } from "@luce/core";
import { useNavigation } from "@luce/core/adapters/navigation";
import { Box, ScreenLayout } from "@luce/ui";

import { PageHeader } from "../../shared";
import { BACK_TO } from "../../shared/lib";
import { AccountInfoContext } from "./account-info-context";
import type { AccountInfoProps } from "./types";

const TITLE = "Account Info";

export function AccountInfoRoot({ onPhoneNumberChanged, children }: AccountInfoProps) {
  const { isDesktop } = useWindowDimensions();
  const { goBack } = useNavigation();

  return (
    <AccountInfoContext.Provider value={{ onPhoneNumberChanged }}>
      <ScreenLayout>
        <ScreenLayout.Header title={TITLE} onBack={() => goBack(BACK_TO.profile)} variant="white" />

        <ScreenLayout.Body scrollable>
          {isDesktop && <PageHeader onBack={() => goBack(BACK_TO.profile)} title={TITLE} />}
          <Box className="gap-spacing-lg p-spacing-lg flex flex-col">{children}</Box>
        </ScreenLayout.Body>
      </ScreenLayout>
    </AccountInfoContext.Provider>
  );
}

AccountInfoRoot.displayName = "AccountInfo";
